import React, { useState } from 'react';
import { useTwilioAppState } from '../../state';
import useDevices from '../../hooks/useDevices';
import Select from '../../../../common/input/select';
import { Logger } from '../../utils';

export default function AudioOutputList() {    
    const { audioOutputDevices } = useDevices();
    const { activeSinkId, setActiveSinkId } = useTwilioAppState();
    const activeDevice = audioOutputDevices.find(device => device.deviceId === activeSinkId);
    const activeOutputLabel = activeDevice ? activeDevice.label : "";
    const renderedOptions = audioOutputDevices.map(device => <option value={device.deviceId} key={device.deviceId}>{device.label}</option>);
    //const [volumeRange, setVolumeRange] = useState(0);

    //const onChangeVolumeRange = (e) => {
    //    let audioEl = document.getElementsByClassName("audio-element")[0];
    //    if (e.target.value > 0) {
    //        audioEl.play();
    //        audioEl.volume = e.target.value / 100;
    //    }
    //    setVolumeRange(e.target.value);
    //};

    return (
        <div className="row">
            <div className="col-12 form-group">
                <label className="label">Speaker</label>
                {audioOutputDevices.length > 1 ?
                    <Select onChange={(e) => {
                        setActiveSinkId(e.target.value);
                        Logger(`UI.Twilio.Room.AudioOutputDevice.OnChange`, new Date(), { newDeviceId: e.target.value });
                    }} value={activeSinkId} renderedOptions={renderedOptions} disableEmptyOption/>
                    : <label>{activeOutputLabel || 'System Default Audio Output'}</label>
                }
            </div>
            {/* <div className="col-12 form-group">
                <span className="icon-line-speaker"/>
                <input type="range" min="0" max="100" className="range" value={volumeRange} onChange={e => onChangeVolumeRange(e)} />
                <audio id="audio" className="audio-element">
                    <source src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3"></source>
                </audio>
            </div>*/}
        </div>
    );
}